var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRebalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31431 11.296C7.19714 11.296 6.29149 12.2016 6.29149 13.3188C6.29149 15.787 8.29237 18.125 10.7606 18.125H12.36C13.4772 18.125 14.4886 17.6722 15.2206 16.94C15.9528 16.2077 16.4056 14.8592 16.4056 13.7422V11.5561C16.4056 11.0035 15.9708 10.5374 15.4183 10.5245C15.1296 10.5178 14.8674 10.6323 14.6791 10.8206C14.4961 11.0037 14.3828 11.2565 14.3828 11.5357V10.5242C14.3828 10.2451 14.2695 9.99224 14.0864 9.80918C13.9034 9.62611 13.6505 9.51283 13.3714 9.51283C13.0922 9.51283 12.8394 9.62611 12.6563 9.80918C12.4732 9.99224 12.36 10.2451 12.36 10.5242M8.31431 11.296V6.4786C8.31431 6.19945 8.42759 5.9466 8.61066 5.76353C8.79898 5.57521 9.06117 5.46075 9.34986 5.46749C9.90236 5.48037 10.3371 5.9464 10.3371 6.49907V10.0691C10.3371 9.78996 10.4504 8.98083 10.6335 8.79777C10.8165 8.6147 11.0694 8.50142 11.3485 8.50142C11.6277 8.50142 11.8805 8.6147 12.0636 8.79777C12.2467 8.98083 12.36 9.23369 12.36 9.51283V10.5242M8.31431 11.296V13.0714M12.36 10.5242V12.2099M10.0546 5.78512C10.8118 5.49282 11.3485 4.7582 11.3485 3.89782M11.3485 3.89782C11.3485 2.78055 10.443 1.875 9.32573 1.875C8.20845 1.875 7.3029 2.78055 7.3029 3.89782M11.3485 3.89782L18.125 3.89782M7.3029 3.89782C7.3029 4.75617 7.83727 5.48945 8.59178 5.78343M7.3029 3.89782L1.875 3.89782M1.875 3.89782L3.08869 2.68413M1.875 3.89782L3.08869 5.11151M18.125 3.89782L16.9113 2.68413M18.125 3.89782L16.9113 5.11151",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRebalance);
export default __webpack_public_path__ + "static/media/rebalance.ba61cb0ba27866e74409ffe8b6221407.svg";
export { ForwardRef as ReactComponent };